export default __webpack_public_path__ + "static/media/sun.f56d43b0.svg";